import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'

import { loginAtom } from '../lib/auth';

import {
  // Box
} from '@mui/material';

import { Page } from '../components/interface/Page';
import { GenericError } from './GenericError';
import { DashboardAdmin } from './dashboard/Admin';
import { DashboardOrganiser } from './dashboard/Organiser';

const { DateTime } = require("luxon");

type DashboardProps = {
  adminAsOrganiser?: boolean;
};

export const Dashboard: FunctionComponent<DashboardProps> = ({adminAsOrganiser}) => {
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);
  
  const [login, setLogin] = useAtom(loginAtom);
  const [loader, setLoader] = useState<boolean>(true);

  return (!!login ? <Page sx={{}} title={t("objects.dashboard.title")}>
    {login?.is_special_permissions && !adminAsOrganiser && <>
      <DashboardAdmin />
    </>}
    {(!!login?.is_organiser || !!adminAsOrganiser) && <>
      <DashboardOrganiser />
    </>}
    {!(login?.is_special_permissions || login?.is_organiser) && <>
      Content when logged in ({login?.is_admin ? 'admin' : login?.is_organiser ? 'organiser' : 'user'})
    </>}
  </Page> : <Page sx={{}} title="PanelMetrics">
    <GenericError hide_detail detail="not_signed_in" cta_label="Sign in now" cta_link="/login" />
  </Page>);
}
